import React from "react";
import { Box, Flex, Text, Link, IconButton, VStack, HStack } from "@chakra-ui/react";
import { FaFacebook, FaInstagram, FaWhatsapp, FaEnvelope, FaMapMarkerAlt  } from "react-icons/fa";

const Footer = () => {
  return (
    <Box bg="gray.900" color="white" py={10} px={6}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="center"
        align="center"
        gap={20}
        maxW="1200px"
        mx="auto"
        flexWrap="wrap"
      >

        <Flex align="center">
          <Box boxSize="250px" mr={3}>
            <img
              src="/images/logo2.webp"
              alt="Beauty Alara logo"
              style={{
                height: "100%",
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </Box>
          <Text fontSize="xl" fontWeight="bold">
            Beauty ALARA
          </Text>
        </Flex>


        <VStack align="flex-start" spacing={1}>
          <Text fontWeight="semibold">Contact</Text>
          <Text>
            <Link href="tel:+32484560531">+32 484 56 05 31</Link>
          </Text>
          <Text>
            <Link href="mailto:beautyalaralaser@gmail.com">
              beautyalaralaser@gmail.com
            </Link>
          </Text>
          <Text>Adres: Brugsesteenweg 384, 9030 Mariakerke(Gent)</Text>
        </VStack>

        <Link
          href="https://www.google.com/local/place/fid/0x47c371a5f40bca8b:0xff7b2ed3f47932b3/photosphere?iu=https://streetviewpixels-pa.googleapis.com/v1/thumbnail?panoid%3D3z-f251OVG8Fin6Q1e0b2w%26cb_client%3Dsearch.gws-prod.gps%26yaw%3D23.302645%26pitch%3D0%26thumbfov%3D100%26w%3D0%26h%3D0&ik=CAISFjN6LWYyNTFPVkc4RmluNlExZTBiMnc%3D&sa=X&ved=2ahUKEwjtp6qpgNiMAxU-TaQEHQKaAXoQpx96BAgdEA4"
          isExternal
          _hover={{ textDecoration: "none" }}
        >
          <Box
            w={{ base: "250px", md: "250px" }}
            h={{ base: "350px", md: "350px" }}
            borderRadius="md"
            overflow="hidden"
            boxShadow="md"
            role="group"
            cursor="pointer"
          >
            <Box
              as="img"
              src="/images/locatie.webp"
              alt="Locatie Beauty Alara"
              w="100%"
              h="100%"
              objectFit="cover"
              transition="transform 0.3s ease"
              _groupHover={{ transform: "scale(1.1)" }}
            />
          </Box>
        </Link>

        <VStack align="center">
          <Text fontWeight="semibold">Volg ons</Text>
          <HStack spacing={4}>
            <IconButton
              as={Link}
              href="https://www.facebook.com/BeautyAlara/"
              aria-label="Facebook"
              icon={<FaFacebook />}
              isRound
              size="lg"
              variant="ghost"
              colorScheme="facebook"
            />
            <IconButton
              as={Link}
              href="https://www.instagram.com/beautyalaralaser/"
              aria-label="Instagram"
              icon={<FaInstagram />}
              isRound
              size="lg"
              variant="ghost"
              colorScheme="pink"
            />
            <IconButton
              as={Link}
              href="https://wa.me/32484560531"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              isRound
              size="lg"
              variant="ghost"
              colorScheme="whatsapp"
            />
            <IconButton
              as={Link}
              href="https://mail.google.com/mail/?view=cm&fs=1&to=beautyalaralaser@gmail.com"
              aria-label="E-mail"
              icon={<FaEnvelope />}
              isRound
              size="lg"
              variant="ghost"
              colorScheme="red"
            />
            <IconButton
              as={Link}
              href="https://www.google.com/maps/dir/?api=1&destination=Brugsesteenweg+384,+9030+Gent"
              aria-label="Route naar Beauty Alara"
              icon={<FaMapMarkerAlt />}
              isRound
              size="lg"
              variant="ghost"
              colorScheme="teal"
              isExternal
            />
          </HStack>
        </VStack>
      </Flex>

      <Text mt={10} fontSize="sm" textAlign="center" color="gray.400">
        &copy; {new Date().getFullYear()} Beauty ALARA. Alle rechten voorbehouden.
      </Text>
    </Box>

  );
};

export default Footer;
